import { useEffect, useRef, useState } from "react";
import { unwrapAngle } from "../lib/geo";

/**
 * Hedef açıyı sarmayan (unwrapped) bir değere çevirir; böylece CSS dönüşü
 * 359° → 1° geçişinde geriye doğru tam tur atmaz.
 */
export function useContinuousAngle(target: number | null): number {
  const [angle, setAngle] = useState(target ?? 0);
  const angleRef = useRef(target ?? 0);

  useEffect(() => {
    if (target === null) return;
    const next = unwrapAngle(angleRef.current, target);
    angleRef.current = next;
    setAngle(next);
  }, [target]);

  return angle;
}
